import React from "react";
import "./kitchen-membership-card.css";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import { useNavigate } from "react-router-dom";



export default function KitchenMembershiplistCard({ item, hideAction = false }) {

    const navigate = useNavigate() 
    // a booking (My Cards) opens with its booking id so pause / resume / cancel are available
    const isBooking = !!item?.booking_id;
    const openMembership = () => {
        navigate(
            `/food-membership-detail/${item.vendor_id}/${item.membership_ticket_id}`,
            isBooking ? { state: { fromPage: 'mymembershiplist', booking_id: item.booking_id } } : undefined
        );
    };
    const DEFAULT_Ticket_IMAGE_URL = "https://theme-assets.getbento.com/sensei/6941e9b.sensei/assets/images/catering-item-placeholder-704x520.png";
    return (
        <div className="kitchen-membership-wrapper">
            <div className="kitchen-membership-card">

                <div
                    className="kitchen-membership-overlay"
                    style={{
                        backgroundImage: item?.ticket_image
                            ? `linear-gradient(to top,rgba(0, 0, 0, 0.7) ,rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0)), 
                             url(https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item?.ticket_image})`
                            : "linear-gradient(to top,rgba(0, 0, 0, 0.7) ,rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0))",
                        backgroundColor: !item?.ticket_image ? "rgb(231, 52, 96)" : "transparent",
                        backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",
                    }}
                ></div>

                <div className="kitchen-membership-content">

                    <h3 className="kitchen-membership-title">
                        <img src={item?.food_type == "1" ? vegIcon : nonvegIcon} alt={item?.food_type} className="kitchen-food-icon me-1" />
                        <span className="kitchen-combo-text">
                            {item?.ticket_name}
                        </span>
                    </h3>

                    <p className="kitchen-membership-desc">
                        {item?.about_ticket}
                    </p> 

                    <div className="kitchen-membership-footer">
                        <span className="kitchen-membership-card-price">
                            <span className="rupeeIcon">₹</span>{item?.ticket_price}
                        </span>
                        {!hideAction && <button className="kitchen-membership-btn" onClick={openMembership}> {isBooking ? "View" : "Buy now"} </button>}
                    </div> 
                </div>
            </div>
        </div>
    );
}